import { useEffect } from "react";

export function useIframeResize() {
  useEffect(() => {
    const sendHeight = () => {
      const height = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);

      window.parent.postMessage(
        {
          type: "campnerd.resize",
          height: height,
        },
        "*",
      );
    };

    sendHeight();

    const observer = new MutationObserver(sendHeight);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
    });

    window.addEventListener("resize", sendHeight);

    return () => {
      observer.disconnect();
      window.removeEventListener("resize", sendHeight);
    };
  }, []);
}
